import React, { useState } from "react";
import { getClass } from "../utils/utils";

const formatter = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 });
const formatAmount = (value) =>
  `${formatter.format(Number(value) || 0)}€`;

const PAGE_SIZE = 10;
const MONTH_PAGE_SIZE = 12;

const ClientSummaryTable = ({ months, rows, firstColumn, onRowClick, showAccountingCode = false }) => {
  const [page, setPage] = useState(1);
  const [monthPage, setMonthPage] = useState(1);
  const pageCount = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
  const currentPage = Math.min(page, pageCount);
  const pageRows = rows.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);
  const monthPageCount = Math.max(1, Math.ceil(months.length / MONTH_PAGE_SIZE));
  const currentMonthPage = Math.min(monthPage, monthPageCount);
  const visibleMonths = months.slice((currentMonthPage - 1) * MONTH_PAGE_SIZE, currentMonthPage * MONTH_PAGE_SIZE);

  return (
    <>
      <div className="client-table-scroll">
        <table className="table client-summary-table">
          <thead>
            <tr>
              {showAccountingCode && <th>Code comptable</th>}
              <th>{firstColumn}</th>
              <th>Total BDC</th>
              {visibleMonths.map((month) => <th key={month}>{month}</th>)}
            </tr>
          </thead>
          <tbody>
            {pageRows.map((row) => (
              <tr
                key={row.id}
                style={{ cursor: onRowClick ? "pointer" : undefined }}
                onClick={onRowClick ? () => onRowClick(row.id) : undefined}
              >
                {showAccountingCode && <td>{row.accountingCode}</td>}
                <td>{row.name}</td>
                <td>{row.total ? <span className={getClass(String(row.total))}>{formatAmount(row.total)}</span> : "0€"}</td>
                {visibleMonths.map((month) => {
                  const value = row.monthlyValues[month] || 0;
                  return (
                    <td key={month}>
                      {value ? <span className={getClass(String(value))}>{formatAmount(value)}</span> : "0€"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {monthPageCount > 1 && (
        <nav className="client-table-pagination" aria-label="Période affichée">
          <button type="button" disabled={currentMonthPage === 1} onClick={() => setMonthPage(currentMonthPage - 1)}>Mois précédents</button>
          <span>{visibleMonths[0]} à {visibleMonths[visibleMonths.length - 1]}</span>
          <button type="button" disabled={currentMonthPage === monthPageCount} onClick={() => setMonthPage(currentMonthPage + 1)}>Mois suivants</button>
        </nav>
      )}
      {pageCount > 1 && (
        <nav className="client-table-pagination" aria-label="Pagination des clients et bons de commande">
          <button type="button" disabled={currentPage === 1} onClick={() => setPage(currentPage - 1)}>Précédent</button>
          <span>Page {currentPage} sur {pageCount} — {rows.length} résultats</span>
          <button type="button" disabled={currentPage === pageCount} onClick={() => setPage(currentPage + 1)}>Suivant</button>
        </nav>
      )}
    </>
  );
};

export { formatAmount };
export default ClientSummaryTable;
